import React, { createContext, useContext, useState } from "react";

const StateContext = createContext();
const initialState = {
  chat: false,
  cart: false,
  userProfile: false,
  notification: false,
};

export const ContextProvider = ({ children }) => {
  const [currentDir, setCurrentDir] = useState("rtl");
  const [currentLang, setCurrentLang] = useState("ar");
  const [currentMode, setCurrentMode] = useState('Light');
  const [currentColor, setCurrentColor] = useState("#A5773A");
  const [activeMenu, setActiveMenu] = useState(true);
  const [isClicked, setIsClicked] = useState(initialState);
  const [screenSize, setScreenSize] = useState(undefined);
  const setDir = (lang) => {
    setCurrentDir(lang);
    console.log("lang", lang);
    localStorage.setItem("themeDir", lang);

    const newlang = lang === "ltr" ? "en" : "ar";

    setCurrentLang(newlang);
    localStorage.setItem("themeLang", newlang);
  };
  const setMode = (Mode) => {
    setCurrentMode(Mode);
    localStorage.setItem('themeMode', Mode);
  };

  const handleClick = (clicked) => setIsClicked({ ...initialState, [clicked]: true });
  return (
    <StateContext.Provider
      value={{ handleClick, isClicked, initialState, setIsClicked,setCurrentLang, currentColor,currentLang, setCurrentDir, currentDir, setDir,activeMenu, setActiveMenu,setScreenSize, screenSize,setMode,currentMode }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
